import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/telegram.vue
var s = {
	name: "DtIconTelegram",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["fill"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--telegram"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Telegram",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [
		i("path", {
			d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
			fill: `url(#${e.uniqueID}a)`
		}, null, 8, l),
		t[1] || (t[1] = i("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M6.527 11.895a496.375 496.375 0 0 1 5.831-2.513c2.777-1.155 3.354-1.355 3.73-1.362.083-.001.268.02.388.116a.421.421 0 0 1 .143.271c.013.078.03.255.016.394-.15 1.581-.802 5.418-1.133 7.19-.14.749-.416 1-.683 1.025-.58.053-1.022-.384-1.584-.753-.88-.577-1.378-.936-2.232-1.499-.987-.65-.347-1.008.215-1.593.148-.153 2.706-2.48 2.756-2.691.006-.026.012-.125-.047-.177-.058-.052-.144-.034-.207-.02-.088.02-1.494.95-4.218 2.788-.399.274-.76.408-1.084.4-.357-.007-1.044-.201-1.555-.367-.626-.204-1.124-.311-1.08-.657.022-.18.27-.364.744-.552Z",
			fill: "#fff"
		}, null, -1)),
		i("defs", null, [i("linearGradient", {
			id: `${e.uniqueID}a`,
			x1: "12",
			y1: "2",
			x2: "12",
			y2: "21.852",
			gradientUnits: "userSpaceOnUse"
		}, [...t[0] || (t[0] = [
			i("stop", { "stop-color": "#2AABEE" }, null, -1),
			i("stop", {
				offset: "0",
				"stop-color": "#2AABEE"
			}, null, -1),
			i("stop", {
				offset: "1",
				"stop-color": "#229ED9"
			}, null, -1)
		])], 8, u)])
	], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=telegram.js.map